export const qrSizes = [
  {text:'235X287', value:'235X287'},
  {text:'372X430', value:'372X430'},
  {text:'562X645', value:'562X645'},
  {text:'610X700', value:'610X700'}
]
